import { CustomCell } from '../../../components/custom-cell';
import { getNumericOperators } from '../../../utils/getNumericOperators';
import { getStringOperators } from '../../../utils/getStringOperators';

export const TABLE_COLUMNS = () => {
	return [
		{
			headerName: '#',
			field: 'id',
			width: 100,
			minWidth: 100,
			align: 'center',
			headerAlign: 'center',
			type: 'number',
			cellClassName: 'id',
			filterOperators: getNumericOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'Название',
			field: 'name',
			flex: 2,
			filterOperators: getStringOperators(),
			renderCell: params => CustomCell(params),
		},
		{ headerName: 'ИНН', field: 'inn', flex: 1, sortable: false },
		{ headerName: 'ОГРН', field: 'ogrn', flex: 1, sortable: false },
		{
			headerName: 'Контактные лица',
			field: 'contact',
			flex: 1,
			sortable: false,
			filterOperators: getStringOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'Телефон',
			field: 'phone',
			flex: 1,
			sortable: false,
			filterOperators: getStringOperators(),
			renderCell: params => CustomCell(params),
		},
	];
};

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const COMPANIES_NAV_PAGE_LIST = [{ text: 'Компании', href: '/companies' }];
